<template>
    <div>
        <toast></toast>
        <div class="accountManage">
            <p class="account_manage_title">My articles</p>
            <div class="addBtn">
                <span @click="goback()">Back</span>
            </div>
            <div class="tab-contents">
                <div class="nano video_breviary" id="accountSettings">
                    <div class="nano-content" id="home_right_list">
                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-2 col-4 tc"><i class="reqiued">*</i>Title</label>
                            <input type="text" v-model='title' class="col-md-3 form-control col-7" />
                        </div>
                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-2 col-4 tc"><i class="reqiued">*</i>Abstract</label>
                            <textarea class="form-control col-7" v-model='description'>

                                                </textarea>
                        </div>
                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-2 col-4 tc"><i class="reqiued">*</i>Text</label>
                            <textarea type="text/plain" v-model='content' id="myEditor" class="col-8" style="height:240px;">
                            </textarea>
                        </div>

                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-2 col-4 tc"><i class="reqiued">*</i>Upload pictures</label>
                            <div class="col-8 pl-0">
                                <img src="static/images/upload.png" @click="clickFile" class="showImg" v-show="!showImg" />
                                <img v-show="showImg" :src="thumb" @click="clickFile" class="showImg" alt=""/>
                                <input type="file" style="display: none" id="upload" @change="tirggerFile($event)" ref="filePicker"/>
                            </div>
                        </div>

                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-2 col-4 tc">Verification code</label>
                            <input type="text" placeholder="Verification code" class="col-md-1 form-control col-5" v-model="captcha" style="width: 200px;max-width: 200px">
                            <img @click='refresh()' :src="codeUrl" id="code" class="border ml-3" style="line-height: 38px;" alt="Verification code" width="65px" height="38px">
                        </div>
                        <!--<div class="w-100 tc mt-3 mb-3">-->
                            <!--<button class="btn btn-primary" @click="" style="width: 100px;">投稿-->
                            <!--</button>-->
                            <!--<button class="btn btn-primary" @click="" style="width: 100px;">保存草稿-->
                            <!--</button>-->
                        <!--</div>-->
                        <div class="form-group row ml-0 mr-0">
                            <label class="col-md-2 col-4 tc">&nbsp;</label>
                            <div class="col-md-8 " style="padding-left: 0px">
                                <p class="myBtn" @click="save(is_draft=0)" >Submit</p>
                                <p class="myBtn cur" @click="save(is_draft=1)" >Save draft</p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </template>

    <script>
        // import './static/css/accountSettings.css'
        import toast from './toast/Toast'
        export default {
            name: "contributeAdd",
            data() {
                return {
                    codeUrl:"/api/pc/captcha/"+Date.parse(new Date()),
                    editor: {},
                    title: "",
                    description: "",
                    content: "",
                    thumb: "",
                    showImg : false,
                    is_draft : 0,
                    captcha : '',
                    id: this.$route.params.id,
                }
            },
            created: function() {


            },
            methods: {
                goback() {
                    this.$router.push({path: "/accountSettings/contribute"});
                },
                clickFile() {
                    const event = new MouseEvent('click');
                    this.$refs.filePicker.dispatchEvent(event);
                },
                tirggerFile(e) {
                    this.deviceArray = [];
                    let that = this;
                    let deviceFile = e.target.files;
                    let formData = new FormData();
                    formData.append('file', deviceFile[0]);
                    let config = {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                    this.$axios.post('/api/pc/uploadavatar', formData, config).then((res) => {
                        if (res.data.state) {
                        that.thumb = res.data.data.path;
                        that.showImg = true;
                        }
                    });
                },
                refresh(){
                    $("#code").attr("src","https://www.imsilkroad.com/api/pc/captcha/"+ Date.parse(new Date()));
                },
                save() {
                    this.content = this.editor.getContent();
                    if (!this.title) {
                        $(".wrap").text('The title should not be blank');
                        $(".wrap").show().delay(1500).hide(100);
                        return;
                    }
                    if (!this.description) {
                        $(".wrap").text('Abstracts cannot be empty');
                        $(".wrap").show().delay(1500).hide(100);
                        return;
                    }
                    if (!this.thumb) {
                        $(".wrap").text('Thumbnails cannot be empty');
                        $(".wrap").show().delay(1500).hide(100);
                        return;
                    }
                    if (!this.content) {
                        $(".wrap").text('Content cannot be empty');
                        $(".wrap").show().delay(1500).hide(100);
                        return;
                    }
                    if (!this.captcha) {
                        $(".wrap").text('Verification code cannot be empty');
                        $(".wrap").show().delay(1500).hide(100);
                        return;
                    }
                    var param = {
                        title: this.title,
                        description: this.description,
                        thumb: this.thumb,
                        content: this.content,
                        is_draft: this.is_draft,
                        captcha: this.captcha
                    }
                    if (this.id) {
                        param.id = this.id;
                    }
                    this.$axios.post('/api/pc/addcontribute', param).then(data => {
                        if (data.data.state) {
                            $(".wrap").text('Released successfully');
                            $(".wrap").show().delay(1500).hide(100);
                            this.clear();
                        } else {
                            $(".wrap").text(data.data.error);
                            $(".wrap").show().delay(1500).hide(100);
                        }
                    })
                },
                clear() {
                    this.content = '';
                    this.title = '';
                    this.description = '';
                    this.captcha = '';
                    this.thumb = '';
                    this.showImg = false;
                    this.editor.setContent(this.content);
                }
            },
            activated() {
//                this.clear();
            },
            mounted() {
                this.load();
                this.editor = UM.getEditor('myEditor');
                // 查看id是否存在
                if (this.id) {
                    this.$axios.post('/api/pc/previewcontribute', {id:this.id}).then((res) => {
                        if (res.data.state) {
                        this.thumb = res.data.data.thumb;
                        this.showImg = true;
                        this.title = res.data.data.title;
                        this.description = res.data.data.description;
                        this.content = res.data.data.content;
                        this.editor.setContent(this.content);
                    }
                });

                }
            },
            components: {
                toast
            }
        }
    </script>

    <style scoped>
        .accountManage {
            position: relative;
        }
        .reqiued{
            color: red;
            margin-right:10px
        }
        .tab-contents{
            padding-top:30px
        }
        .tab-contents lable{
            padding-left:0;
            padding-right:0;
        }
        .myBtn.cur{
            background:rgba(242,243,244,.8);
            color:rgba(133,144,166,1);
            margin-left:30px!important;
        }
        .myBtn.cur:hover{
            background:rgba(242,243,244,1);
            cursor:pointer;
        }
        .myBtn:hover{
            background:rgba(32,142,255,1);
            cursor:pointer;
        }
        .showImg{
            width:220px;
            height:166px;
        }
        .myBtn{
            width:140px;
            height:34px;
            background:rgba(32,142,255,.8);
            border-radius:4px;
            font-size:14px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            text-align:center;
            color:rgba(255,255,255,1);
            line-height:34px;
            display:inline-block
        }
        .addBtn {
            position: absolute;
            right: 40px;
            top: 20px;
            width: 60px;
            height: 30px;
            background: rgba(242, 243, 244, 1);
            border-radius: 20px;
            text-align: center;
        }

        .addBtn:hover {
            cursor: pointer;
        }

        .addBtn span {
            font-size: 12px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(133, 144, 166, 1);
            line-height: 30px;
            display: block;
        }
    </style>
